<template>
  <div>
    <v-container no-gutters pa-0>
      <v-row no-gutters>
        <v-col>
          <v-menu
            ref="popup"
            bottom
            origin="center center"
            transition="scale-transition"
            v-model="showTrans"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{}">
              <v-textarea
                v-if="capsOn"
                v-bind="$attrs"
                v-on="$listeners"
                :value="innerValue[language.language.toUpperCase()]"
                @input="onLanguageInput($event, language.language)"
                :rows="1"
                auto-grow
              ></v-textarea>
              <v-textarea
                v-else
                v-bind="$attrs"
                v-on="$listeners"
                :value="
                  innerValue[
                    $helpers.correctCase(language.language, innerValue)
                  ]
                "
                @input="onLanguageInput($event, language.language)"
                :rows="1"
                auto-grow
              ></v-textarea>
            </template>
            <v-list>
              <v-list-item
                v-for="(lang, index) of languages.filter(
                  (l) => l.language !== language.language
                )"
                :key="index"
              >
                <template v-if="showTrans">
                  <v-textarea
                    v-bind="$attrs"
                    v-on="$listeners"
                    v-if="capsOn"
                    v-on:keydown.tab="
                      $refs.button.$el.focus();
                      showTrans = false;
                    "
                    :value="innerValue[lang.language.toUpperCase()]"
                    @input="onLanguageInput($event, lang.language)"
                    :label="lang.language.toUpperCase()"
                    :rows="1"
                    auto-grow
                    :ref="`translations${index}`"
                  ></v-textarea>
                  <v-textarea
                    v-bind="$attrs"
                    v-on="$listeners"
                    v-else
                    v-on:keydown.tab="
                      $refs.button.$el.focus();
                      showTrans = false;
                    "
                    :value="
                      innerValue[
                        $helpers.correctCase(lang.language, innerValue)
                      ]
                    "
                    @input="onLanguageInput($event, lang.language)"
                    :label="lang.language.toUpperCase()"
                    :rows="1"
                    auto-grow
                    :ref="`translations${index}`"
                  ></v-textarea>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col
          cols="auto"
          v-if="languages.length > 1"
          style="margin-top:20px;margin-left:3px"
        >
          <v-btn
            ref="button"
            @click="openAndFocus()"
            depressed
            small
            color="success"
          >
            <v-icon>language</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { isObject } from "vuetify/lib/util/helpers";
import { mapGetters } from "vuex";
export default {
  props: ["value", "capsOn"],
  data() {
    return {
      showTrans: false,
      innerValue: {},
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
  },
  watch: {
    dialog: {
      handler(v) {
        if (!v) this.showTrans = false;
      },
    },
    value: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.innerValue = JSON.parse(JSON.stringify(v));
        } else {
          this.innerValue = {};
        }
      },
    },
    // innerValue: {
    //   handler(v) {
    //     console.log(v);
    //   },
    // },
  },
  mounted() {
    // console.log("mounted", this.value)
    if (this.value !== null && this.value !== undefined) {
      this.innerValue = JSON.parse(JSON.stringify(this.value));
    } else {
      this.innerValue = {};
    }
  },
  methods: {
    onLanguageInput(v, lang) {
      let val = {};
      if (isObject(this.innerValue)) {
        val = JSON.parse(JSON.stringify(this.innerValue));
      }
      if (this.capsOn) {
        val[lang.toUpperCase()] = v;
      } else {
        val[this.$helpers.correctCase(lang, this.innerValue)] = v;
      }

      this.$nextTick(() => {
        // this.innerValue = val;
        this.$emit("update:value", val);
        this.$forceUpdate();
      });
    },
    openAndFocus() {
      this.showTrans = !this.showTrans;
      const t = setTimeout(() => {
        // console.log(this.$refs["translations0"])
        this.$refs["translations0"][0].focus();
        clearTimeout(t);
      }, 100);
    },
  },
};
</script>
